import * as React from 'react';
import * as Styled from './OfflineStudio.styles';
import Divider from '@ids/components/Layout/Divider';
import { useFeatureToggle } from '@ids/appshell';
import { useOfflineStudioBlock } from '@ids/context';
import { useIdsGaTracking, useQuestionnaireFlow } from '@ids/hooks';

function OfflineStudio() {
    const data = useOfflineStudioBlock();
    const { trackIdsEvent } = useIdsGaTracking();
    const { p100StudioOffline } = useFeatureToggle();
    const { startQuestionnaire } = useQuestionnaireFlow();

    const startSSFlow = React.useCallback(() => {
        if (!data?.surveySparrowConfig || !data?.idsCouponSku) {
            return;
        }
        trackIdsEvent({ action: 'Price Tiers', label: 'Offline Studio CTA' });
        startQuestionnaire({
            surveySparrowConfig: data.surveySparrowConfig,
            sku: data.idsCouponSku,
        });
    }, [data?.idsCouponSku, data?.surveySparrowConfig, startQuestionnaire, trackIdsEvent]);

    if (!data || !p100StudioOffline) {
        return <React.Fragment key="offline-studio" />;
    }

    const { image, promotionalTag, title, description, hintText, ctaText } = data;

    return (
        <React.Fragment key="offline-studio">
            <Styled.OfflineStudioSection id="offline-studio" data-testid="offline-studio-block">
                <Styled.MediaContainer>
                    <Styled.Image
                        image={image}
                        sizes="(max-width: 767px) 100vw, 70vw"
                        layout="responsive"
                        width={image.file.details.image.width}
                        height={image.file.details.image.height}
                    />
                </Styled.MediaContainer>
                <Styled.TextBox>
                    {promotionalTag ? <Styled.PromotionalTag>{promotionalTag}</Styled.PromotionalTag> : null}
                    <Styled.Title>{title}</Styled.Title>
                    <Styled.Description content={description} />
                    <Styled.Hint>{hintText}</Styled.Hint>
                    <Styled.CTAButton onClick={startSSFlow} data-testid="offline-studio-cta-button">
                        {ctaText}
                    </Styled.CTAButton>
                </Styled.TextBox>
            </Styled.OfflineStudioSection>
            <Divider />
        </React.Fragment>
    );
}

export default OfflineStudio;
